export const COMPANY_TYPE = {
    service: 'service',
    child: 'child',
};
